<div class="container-fluid banner error-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-sm-12">
                <div class="banner-title">
                    <h1>We're sorry. It seems somthing went wrong.</h1>
                    <p>
                        The page you are looking for cannot be found. <br>Please select from the options below to proceed.
                        <br><br>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<!--- ====================BODY START======================= -->
<section class="section-full">
    <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <div class="mb-error-title">
                    <div class="mb-error-title-b">404</div>
                    <div class="mb-error-title-a">ERROR</div>

                    <div class="mb-error-title-c">PAGE NOT FOUND</div>
                </div>
            </div>
            <div class="col-lg-6">
                <p class="error-para">
                    Maybe one of these pages can help you to find what youre looking for.
                </p>
                <div class="col-lg-6">
                    <ul class="error-links">
                        <li><strong>Support</strong></li>
                        <li><a href="#">Browse Counsellors </a></li>
                        <li><a href="#">For Counsellors/Therapists </a></li>
                        <li><a href="#">Topics in Counselling </a></li>
                        <li><a href="#">Mental Health Section</a></li>
                        <li><a href="#">How does Online Counselling work?</a></li>
                        <li><a href="#">MindBerry FAQ</a></li>
                        <li><a href="#">Approaches to Therapy </a></li>
                        <li><a href="#">Emergency Contacts </a></li>
                    </ul>
                </div>
                <div class="col-lg-6">
                    <ul class="error-links">
                        <li><strong>Services</strong></li>
                        <li><a href="#">Students</a></li>
                        <li><a href="#">Love</a></li>
                        <li><a href="#">Family</a></li>
                        <li><a href="#">LGBT+</a></li>
                        <li><a href="#">Veterans</a></li>
                        <li><a href="#">Silver</a></li>
                        <li><a href="#">Business</a></li>
                        <li><a href="#">Men’s Health</a></li>
                        <li><a href="#">Women’s Health</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>
<div class="container-fluid body-newsletter body-padding-small">
    <div class="container body-container">
        <div class="col-lg-4 col-md-4 col-sm-4">
            <div class="newsletter-cnt">
                <h4><strong>Subscribe to our Newsletter</strong></h4>
                <p>
                    Stay-up-to-date with <strong>MindBerry</strong>. learn
                    more about mental health, upcoming events and exclusive promotions!
                </p>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6">
            <div class="newsletter-input">
                <input type="text" placeholder="enter email address...">
            </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-2">
            <div class="newsletter-button">
                <button type="submit">Subscribe!</button>
            </div>
        </div>
    </div>
</div>
<!--- ====================BODY END======================= -->